import { FC } from 'react';

import styled from 'styled-components';

import { CheckOutlineIcon } from '@assets/icons';

const CheckMark = styled(CheckOutlineIcon)`
  position: relative;
  z-index: 1;
  color: ${({ theme, checkMarkColor }) =>
    checkMarkColor ?? theme.palette.white};
`;

const Container = styled.div<{
  clickable?: boolean;
  outlineColor?: string;
  checkMarkColor?: string;
  checkBackgroundColor?: string;
}>`
  width: 16px;
  height: 16px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  background-color: ${({ theme, checkBackgroundColor }) =>
    checkBackgroundColor ?? theme.palette.primaryBrand};
  border-radius: 4px;
`;

export const Unchecked = styled.div<{
  checked?: boolean;
  outlineColor?: string;
}>`
  width: 16px;
  height: 16px;
  min-width: 16px;
  border-radius: 4px;
  align-self: center;
  border: 1px solid
    ${({ theme, outlineColor }) => outlineColor ?? theme.palette.grey300};
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
  ${({ onClick }) => onClick && 'cursor: pointer'}
`;

type CheckIconProps = {
  checked: boolean;
  onClick?(): void;
  outlineColor?: string;
  checkMarkColor?: string;
  checkBackgroundColor?: string;
};

const CheckIcon: FC<CheckIconProps> = ({
  checked,
  onClick,
  checkMarkColor,
  outlineColor,
  checkBackgroundColor,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    onClick?.();
  };
  return checked ? (
    <Container
      onClick={handleClick}
      clickable={!!onClick}
      checkBackgroundColor={checkBackgroundColor}
    >
      <CheckMark checkMarkColor={checkMarkColor} />
    </Container>
  ) : (
    <Unchecked onClick={handleClick} outlineColor={outlineColor} />
  );
};

export default CheckIcon;
